<template>
    <div class="vertical-logo">
        <b-img :src="require('../../assets/img/logotipo_sem_texto_small.png')"
            fluid
            alt="barbosa peixe logotipo">
        </b-img>
        <h3 class="logoTitle">
            BARBOSA PEIXE
        </h3>
    </div>
</template>

<script>
export default {
    name: 'Logovertical',
    props: {}
}
</script>
